import React from 'react';
import Step from './Step';
import ExpandableContainer from './ExpandableContainer';
import store from '../../../store/configuration';
import HeatExchangerRequirements from './HeatExchangerRequirements';
import * as Row from '../../layout/Row';
import StepModel from '../../../model/configurator/StepModel';
import Field from '../../../model/configurator/Field';
import HeatExchangerField from '../../../model/configurator/heating/HeatExchangerField';
import QuickStepSetupField from '../../../model/configurator/heating/QuickStepSetupField';
import IsSparePumpField from '../../../model/configurator/heating/IsSparePumpField';
import IsPumpSparePartField from '../../../model/configurator/heating/IsPumpSparePartField';
import CrossReferencedHeatingField from '../../../model/configurator/controller/CrossReferencedHeatingField';
import {GetPumpLiftingHeightTips} from './helpers/heatingHelpers';
import PumpAdditionalFilters from './common/PumpAdditionalFilters';
import HeatPumpConnections from './common/HeatPumpConnections';
import StepHorizontalField from './StepHorizontalField';

export default class StepDHW extends Step {
    state = {
        pumpAdditionalFilterSectionVisible: false
    }

    constructor(props) {
        super(props)

        this.calculationUpdateTimeout = -1

        scheduleAtDocumentReady(() => {
            var {dhw} = this.props.model
            if (dhw.heatExchangerOutput && Object.keys(dhw.heatExchangerOutput)[0]) {
                store.setDHWCalculationOutput({
                    heatExchangerOutput: dhw.heatExchangerOutput
                })
            }
        })
    }

    renderBody(model) {
        model = model.dhw

        return (
            <React.Fragment>
                <div className="row row-no-outer-gutter flex-center-v" style={{marginBottom: '1rem'}}>
                    <div className="column-6">
                        {this.renderGenericHorizontalField(this.fields.capacity)}
                    </div>

                    <div className="column-6">
                        {this.renderGenericHorizontalField(this.fields.quickStepSetup)}
                    </div>
                </div>

                <HeatExchangerRequirements
                    model={model}
                    primary={this.fields.primary}
                    secondary={this.fields.secondary}
                    plateType={this.fields.plateType}
                    numberOfPlates={this.fields.numberOfPlates}
                    margin={this.fields.margin}
                    marginLock={this.fields.marginLock}
                    renderField={this.renderFieldv2}
                >
                    {this.renderTwoStroke()}
                    {this.renderConnectionType(model)}
                    <HeatExchangerRequirements.RightSideUnderExchangerSides>
                        {this.props.model.unitType.isMaxiCompactLogic.value && this.renderGenericHorizontalField(this.fields.safetyValve)}
                    </HeatExchangerRequirements.RightSideUnderExchangerSides>
                </HeatExchangerRequirements>

                <div className="row row-no-outer-gutter">
                    <div className="column-6 column-xs-12">
                        <div style={{
                            marginLeft: '60px',
                            marginBottom: '10px'
                        }}>{this.renderFieldv2(this.fields.secondarySideIncluded)}</div>
                        <div style={{
                            marginLeft: '60px',
                            marginBottom: '10px'
                        }}>{this.renderFieldv2(this.fields.proPlusDhwPreheating)}</div>
                        <div style={{
                            marginLeft: '60px',
                            marginBottom: '10px'
                        }}>{this.renderFieldv2(this.fields.hotWaterCirculation)}</div>
                        <div
                            style={{marginLeft: '60px'}}>{this.renderFieldv2(this.fields.heatPumpConnectionsIncluded)}</div>
                    </div>
                </div>
                {this.fields.secondarySideIncluded.value ? (
                    <React.Fragment>
                        {this.renderSection(this.fields.secondaryPipeSize,
                            this.fields.circulationValve,
                            this.fields.coldWaterMeter,
                            this.fields.waterMeterCommunication,
                            this.fields.circulationPipeSize,
                            this.fields.safetyValve,
                            this.fields.coldWaterStrainer,
                            this.fields.circulationStrainer,
                            this.fields.manometer) && this.renderSecondarySideComponents(model)}
                    </React.Fragment>
                ) : ''}
                {this.fields.proPlusDhwPreheating.value && (
                    <React.Fragment>
                        {this.renderDHWpreheating()}
                    </React.Fragment>
                )}
                {this.fields.secondarySideIncluded.value ? (
                    <React.Fragment>
                        {this.fields.hotWaterCirculation.value === true ? (
                            <React.Fragment>
                                {this.renderPump(model)}
                            </React.Fragment>
                        ) : ''}
                    </React.Fragment>
                ) : ''}
                <HeatPumpConnections fields={this.fields}
                                     renderGenericHorizontalField={this.renderGenericHorizontalField}/>
            </React.Fragment>
        )
    }

    renderTwoStroke() {
        if (this.fields.isTwoStroke.visible) {
            return (
                <div className="row row-no-outer-gutter">
                    <div className="column-6 column-xs-12">
                        <div style={{
                            marginLeft: '75px',
                            marginBottom: '10px',
                            marginTop: '10px'
                        }}>{this.renderFieldv2(this.fields.isTwoStroke)}</div>
                    </div>
                </div>
            )
        }

        return <React.Fragment/>
    }

    renderConnectionType(model) {
        if (!this.fields.connectionTypeH1.visible &&
            !this.fields.connectionTypeH2.visible &&
            !this.fields.connectionTypeH3.visible) {
            return <React.Fragment></React.Fragment>;
        }

        return (
            <div className="row row-no-outer-gutter">
                <div className="configuration-field-container dhw-connection-type" style={{width: '100%'}}>
                    <div className="configuration-field-row" style={{display: 'flex'}}>
                        <div className="field-column1" style={{width: '20.5%', marginTop: '22px'}}>
                            {__('Connection type')}
                        </div>
                        <div className="field-column2" style={{display: 'flex', width: '79.5%'}}>
                            <Row.Container hasOuterGutter={false} className="w-100">
                                <Row.Column4>
                                    <span
                                        className="configuration-editor-controller-heating-label">{this.props.model.heating1.name.value}</span>
                                    {this.renderFieldv2(this.fields.connectionTypeH1)}
                                </Row.Column4>

                                {this.props.model.heating2 ?
                                    <Row.Column4>
                                        <span
                                            className="configuration-editor-controller-heating-label">{this.props.model.heating2.name.value}</span>
                                        {this.renderFieldv2(this.fields.connectionTypeH2)}
                                    </Row.Column4>
                                    : ''}

                                {this.props.model.heating3 ?
                                    <Row.Column4>
                                        <span
                                            className="configuration-editor-controller-heating-label">{this.props.model.heating3.name.value}</span>
                                        {this.renderFieldv2(this.fields.connectionTypeH3)}
                                    </Row.Column4>
                                    : ''}
                            </Row.Container>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    round(n, precision) {
        var m = Math.pow(10, precision);
        return Math.round(n * m) / m;
    }

    renderSecondarySideComponents(model) {
        const warnings = [
            this.fields.secondaryPipeSize,
            this.fields.circulationValve,
            this.fields.coldWaterMeter,
            this.fields.waterMeterCommunication,
            this.fields.circulationPipeSize,
            this.fields.safetyValve,
            this.fields.coldWaterStrainer,
            this.fields.circulationStrainer,
            this.fields.manometer,
            this.fields.pumpStopThermostat
        ].filter(x => x.visible).map(s => s.warning);

        return (
            <ExpandableContainer warnings={warnings} label={__('Secondary side components')}>
                <Row.Container hasOuterGutter={false}>
                    <Row.Column6 hidden={
                        !this.fields.secondaryPipeSize.visible &&
                        !this.fields.circulationValve.visible &&
                        !this.fields.coldWaterMeter.visible &&
                        !this.fields.waterMeterCommunication.visible &&
                        !this.fields.circulationPipeSize.visible &&
                        !this.fields.safetyValve.visible &&
                        !this.fields.coldWaterStrainer.visible &&
                        !this.fields.circulationStrainer.visible &&
                        !this.fields.manometer.visible &&
                        !this.fields.serviceBypass.visible &&
                        !this.fields.ThermostaticSafetyMixingValve.visible &&
                        !this.fields.satefyShutOff.visible
                    }>
                        {this.renderGenericHorizontalField(this.fields.secondaryPipeSize, {}, this.doFieldsHaveValues(model.secondaryPipeDN) && this.fields.secondaryPipeSize.visible ? [
                            `${__('DN')}: ${model.secondaryPipeDN.value}`
                        ] : [])}

                        {this.renderGenericHorizontalField(this.fields.circulationValve, {}, model.circulationValvePerformance !== null && model.circulationValvePerformance.value !== null ? [
                            `${__('dp')}: ${this.round(model.circulationValvePerformance.value.pressureDrop, 3)} ${__('kPa')}`,
                            `${__('kvs')}: ${this.round(model.circulationValvePerformance.value.kvs, 1)}`
                        ] : [])}

                        {this.renderGenericHorizontalField(this.fields.coldWaterMeter)}
                        {this.renderGenericHorizontalField(this.fields.waterMeterCommunication)}
                        {this.renderGenericHorizontalField(this.fields.ThermostaticSafetyMixingValve)}
                    </Row.Column6>

                    <Row.Column6>
                        {this.renderGenericHorizontalField(this.fields.circulationPipeSize, {}, this.doFieldsHaveValues(model.circulationPipeDN) ? [
                            `${__('DN')}: ${model.circulationPipeDN.value}`
                        ] : [])}

                        {!this.props.model.unitType.isMaxiCompactLogic.value && this.renderGenericHorizontalField(this.fields.safetyValve)}
                        {this.renderGenericHorizontalField(this.fields.coldWaterStrainer)}
                        {this.renderGenericHorizontalField(this.fields.circulationStrainer)}
                        {this.renderGenericHorizontalField(this.fields.manometer)}
                        {this.renderGenericHorizontalField(this.fields.serviceBypass)}
                        {this.renderGenericHorizontalField(this.fields.satefyShutOff)}
                    </Row.Column6>
                </Row.Container>
            </ExpandableContainer>
        )
    }

    renderDHWpreheating() {
        let warnings = [
            this.fields.dhwPreheatingKitHeatExchanger,
            this.fields.dhwPreheatingKitPump,
            this.fields.dhwPreheatingKitThreeWayValve,
            this.fields.dhwPreheatingKitActuator
        ].filter(x => x.visible).map(x => x.warning);

        return (
            <ExpandableContainer warnings={warnings} label={__('DHW preheating')}>
                <React.Fragment>
                    <div className="row row-no-outer-gutter" style={{marginTop: '1rem'}}>
                        <div className="column-6">
                            {this.renderGenericHorizontalField(this.fields.dhwPreheatingKitHeatExchanger)}
                            {this.renderGenericHorizontalField(this.fields.dhwPreheatingKitPump)}
                        </div>
                        <div className="column-6">
                            {this.renderGenericHorizontalField(this.fields.dhwPreheatingKitThreeWayValve)}
                            {this.renderGenericHorizontalField(this.fields.dhwPreheatingKitActuator)}
                        </div>
                    </div>
                </React.Fragment>
            </ExpandableContainer>
        )
    }

    renderPump(model) {
        let warnings = [
            this.fields.circulationFlowFactor,
            this.fields.pumpManufacturer,
            this.fields.pump,
            this.fields.networkPressureDrop,
            this.fields.requiredLiftingHeight,
            this.fields.pumpFlow
        ].filter(x => x.visible).map(x => x.warning);

        const setCirculationFlowFactorDefaultValue = () => {
            this.fields.circulationFlowFactor.value = this.fields.circulationFlowFactor.default
            if (this.props.onFormModelChange) {
                this.props.onFormModelChange()
            }
        }
        let pumpModelTips = GetPumpLiftingHeightTips(model)
        const onAdditionalFiltersClick = () => this.setState(prev => ({pumpAdditionalFilterSectionVisible: !prev.pumpAdditionalFilterSectionVisible}));

        return (
            <ExpandableContainer warnings={warnings} label={__('Pump')}>
                <React.Fragment>
                    <div className="row row-no-outer-gutter" style={{marginTop: '1rem'}}>
                        {(this.fields.pumpManufacturer.visible || this.fields.pump.visible || this.fields.circulationFlowFactor.visible) && (
                            <div className="column-6">
                                {this.renderGenericHorizontalField(this.fields.pumpManufacturer)}
                                {this.renderGenericHorizontalField(this.fields.pump, {}, pumpModelTips, undefined, 'has-additional-filters-container', () => {
                                    return (
                                        <PumpAdditionalFilters
                                            fields={this.fields}
                                            renderGenericHorizontalField={this.renderGenericHorizontalField}
                                            visible={this.state.pumpAdditionalFilterSectionVisible}
                                            onVisibleClick={onAdditionalFiltersClick}
                                        />
                                    )
                                })}
                                {this.renderGenericHorizontalField(this.fields.isSparePump, {renderLabel: false})}
                                {this.renderGenericHorizontalField(this.fields.pumpStopThermostat)}
                                {this.renderGenericHorizontalField(this.fields.isPumpSparePart, {renderLabel: false})}
                                {this.renderGenericHorizontalField(this.fields.circulationFlowFactor)}
                            </div>
                        )}

                        <div className="column-6">
                            {this.renderGenericHorizontalField(this.fields.networkPressureDrop)}
                            {this.renderGenericHorizontalField(this.fields.requiredLiftingHeight)}
                            {this.renderGenericHorizontalField(this.fields.pumpFlow, {}, [], setCirculationFlowFactorDefaultValue)}
                        </div>
                    </div>
                </React.Fragment>
            </ExpandableContainer>
        )
    }

    static getFields(step) {
        const createField = name => new Field(name, step)
        const createExchangerSide = name => {
            return {
                inletTemperature: new HeatExchangerField(name + '.inletTemperature', step),
                outletTemperature: new HeatExchangerField(name + '.outletTemperature', step),
                fluid: new HeatExchangerField(name + '.fluid', step),
                flow: new HeatExchangerField(name + '.flow', step),
                maxPressureDrop: new HeatExchangerField(name + '.maxPressureDrop', step),
            }
        }

        return {
            capacity: createField('capacity'),
            quickStepSetup: new QuickStepSetupField('quickStepSetup', step),
            primary: createExchangerSide('primary'),
            secondary: createExchangerSide('secondary'),
            heatExchangerName: createField('heatExchangerName'),
            numberOfPlates: createField('numberOfPlates'),
            plateType: createField('plateType'),
            margin: createField('margin'),
            marginLock: createField('marginLock'),
            secondarySideIncluded: createField('secondarySideIncluded'),
            proPlusDhwPreheating: createField('proPlusDhwPreheating'),
            dhwPreheatingKitHeatExchanger: createField('dhwPreheatingKitHeatExchanger'),
            dhwPreheatingKitPump: createField('dhwPreheatingKitPump'),
            dhwPreheatingKitThreeWayValve: createField('dhwPreheatingKitThreeWayValve'),
            dhwPreheatingKitActuator: createField('dhwPreheatingKitActuator'),
            hotWaterCirculation: createField('hotWaterCirculation'),
            circulationPipeSize: createField('circulationPipeSize'),
            secondaryPipeSize: createField('secondaryPipeSize'),
            safetyValve: createField('safetyValve'),
            coldWaterStrainer: createField('coldWaterStrainer'),
            circulationStrainer: createField('circulationStrainer'),
            circulationValve: createField('circulationValve'),
            coldWaterMeter: createField('coldWaterMeter'),
            waterMeterCommunication: createField('waterMeterCommunication'),
            manometer: createField('manometer'),
            serviceBypass: createField('serviceBypass'),
            ThermostaticSafetyMixingValve: createField('thermostaticSafetyMixingValve'),
            satefyShutOff: createField('satefyShutOff'),
            pumpManufacturer: createField('pumpManufacturer'),
            pump: createField('pump'),
            isSparePump: new IsSparePumpField('isSparePump', step),
            isPumpSparePart: new IsPumpSparePartField('isPumpSparePart', step),
            singleTwin: createField('singleTwin'),
            adjustable: createField('adjustable'),
            dryMotor: createField('dryMotor'),
            powerSupply: createField('powerSupply'),
            pumpFlow: createField('pumpFlow'),
            circulationFlowFactor: createField('circulationFlowFactor'),
            networkPressureDrop: createField('networkPressureDrop'),
            requiredLiftingHeight: createField('requiredLiftingHeight'),
            connectionTypeH1: new CrossReferencedHeatingField('is2Step', step, 1),
            connectionTypeH2: new CrossReferencedHeatingField('is2Step', step, 2),
            connectionTypeH3: new CrossReferencedHeatingField('is2Step', step, 3),
            isTwoStroke: createField('isTwoStroke'),
            heatPumpConnectionsIncluded: createField('heatPumpConnectionsIncluded'),
            connectionTypeDN: createField('connectionTypeDN'),
            nonReturnValveHeatingSupply: createField('nonReturnValveHeatingSupply'),
            nonReturnValveHPReturn: createField('nonReturnValveHPReturn'),
            threeWayValve: createField('threeWayValve'),
            balancingValveHPSupply: createField('balancingValveHPSupply'),
            separateHeatExchanger: createField('separateHeatExchanger'),

            pumpAddOn: createField('pumpAddOn'),
            temperature: new Field('design.temperature', step, false),
            pressure: new Field('design.pressure', step, false),
            pn: createField('design.pn'),
            preHeaterPressureDrop: createField('preHeaterPressureDrop'),
            pumpStopThermostat: createField('pumpStopThermostat'),
        }
    }

    static getStepModel(model) {
        return new StepModel('dhw', model.dhw)
    }


}